export const SOFTWARE_TYPE_PC = "pc";
export const SOFTWARE_TYPE_MOBILE = "mobile";
export const SESSION_KEY_SOFT_VERSION_CLIENT_TYPE = "soft_version_client_type";

export function isMobileSoftRecord(el) {
  return el?.software_client_rel?.type === "TSD";
}

export function getSoftwareTypeFromSession() {
  try {
    const stored = sessionStorage.getItem(SESSION_KEY_SOFT_VERSION_CLIENT_TYPE);
    if (stored === SOFTWARE_TYPE_MOBILE) {
      return SOFTWARE_TYPE_MOBILE;
    }
  } catch {
    /* ignore */
  }
  return SOFTWARE_TYPE_PC;
}

export function setSoftwareTypeInSession(mode) {
  try {
    sessionStorage.setItem(
      SESSION_KEY_SOFT_VERSION_CLIENT_TYPE,
      mode === SOFTWARE_TYPE_MOBILE ? SOFTWARE_TYPE_MOBILE : SOFTWARE_TYPE_PC,
    );
  } catch {
    /* ignore */
  }
}

/**
 * @param {object} el — запись софта с software_client_rel
 * @param {"pc"|"mobile"} mode
 */
export function matchesSoftwareTypeMode(el, mode) {
  const mobile = isMobileSoftRecord(el);
  if (mode === SOFTWARE_TYPE_MOBILE) {
    return mobile;
  }
  return !mobile;
}
